@if (isApplicable) {
  <div class="trigger" (click)="onTriggerClicked()">
    <span class="link">
      <mat-icon svgIcon="advent-calendar-overlay"></mat-icon>
      @if (!isOverlayVisible) {
        {{ 'i18n.adventCalendarOverlay.activate' | translate }}
      }
      @if (isOverlayVisible) {
        {{ 'i18n.adventCalendarOverlay.deactivate' | translate }}
      }
    </span>
    <span class="notice">
      {{ 'i18n.adventCalendarOverlay.notice' | translate }}
    </span>
  </div>
}
